module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“GIRL, WHY YOU")]), _vm._v(" balled-up in the bedclothes there? Come on out now, or I’ll pull you out myself, like I did yesterday. You didn’t like that, did you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yesterday? The soldier can’t remember yesterday.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A wave of cold as the nurse pulls off the sheet. Wet gown bunched and piss-stinky. Back throbbing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh, honey. You had a rough night, huh? Come on, up you get and we’ll wash you nice and clean.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The nurse wraps her big arms around the soldier and drags her out of the hospital bed, wet and reeking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The nurse and the soldier dancing the waltz of shame.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f86cf91","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781569479674_Split8.vue
// module id = 81
// module chunks = 0